<template>
    <tr :class="`${isEditRequested ? 'edit-row' : ''}`">
        <td>
            {{ supply.name }}
        </td>
        <td>
            {{ supply.unitCost }}
        </td>
        <td>
            <span v-if="supply.isFormulary === true">Yes</span>
            <span v-if="supply.isFormulary === false">No</span>
            <small v-if="!isSupplyFormularyBoolean">
                <i class="text-default">Not Available</i>
            </small>
        </td>
        <td v-if="!isDeleteRequested">
            <span v-if="!isEditRequested">
                <span v-if="supply.startDate">
                    {{ formatDate(supply.startDate) }}
                </span>
                <span v-else> - </span>
            </span>
            <DatePicker :getDate="onDateChange" v-else>
                <div class="input-group date datepickerInput">
                    <input
                        name="supplyStartDate"
                        type="text"
                        class="form-control"
                        :value="formatDateInput(supply.startDate)"
                        placeholder="MM/DD/YYYY"
                        date-format-only
                        @blur="v$.supply.startDate.$touch"
                        :class="`${!v$.supply.startDate.$error ? '' : 'field-invalid'}`"
                    />
                    <div class="input-group-addon input-group-append">
                        <div class="input-group-text">
                            <i class="fa fa-calendar"></i>
                        </div>
                    </div>
                </div>
            </DatePicker>
        </td>
        <td v-if="!isDeleteRequested">
            <span v-if="!isEditRequested">
                <span v-if="supply.endDate">
                    {{ formatDate(supply.endDate) }}
                </span>
                <span v-else> - </span>
            </span>
            <DatePicker v-else>
                <div class="input-group date datepickerInput">
                    <input
                        name="supplyEndDate"
                        type="text"
                        class="form-control"
                        :value="formatDateInput(supply.endDate)"
                        placeholder="MM/DD/YYYY"
                        date-format-only
                    />
                    <div class="input-group-addon input-group-append">
                        <div class="input-group-text">
                            <i class="fa fa-calendar"></i>
                        </div>
                    </div>
                </div>
            </DatePicker>
        </td>
        <!-- ACTIONS -->
        <td class="text-end" v-if="!isEditRequested && !isDeleteRequested">
            <button type="button" class="btn table-btn btn-outline-info" @click="editSupply()">
                <i class="fas fa-edit"></i>
            </button>
            <button
                type="button"
                class="btn table-btn btn-outline-danger"
                @click="requestDeleteSupply()"
                v-if="!supply.id"
            >
                <i class="fas fa-trash-alt"></i>
            </button>
        </td>
        <!-- EDIT -->
        <td class="button-cell text-end" v-if="isEditRequested">
            <button type="button" class="btn table-btn btn-outline-success" @click="saveEdit()">Save</button>
            <button type="button" class="btn table-btn btn-outline-secondary" @click="cancelEdit()">Cancel</button>
        </td>
        <!-- DELETE -->
        <td colspan="3" v-if="isDeleteRequested">
            <TablePrompt
                :message="`Are you sure want to delete ${supply.name}?`"
                ok-text="delete"
                name="Delete"
                :ok="deleteSupply()"
                :cancel="cancelDelete()"
            >
            </TablePrompt>
        </td>
    </tr>
</template>

<script lang="ts" src="./SupplyTableRow.ts"></script>
